import axios from 'axios';

import { getInstitution } from './getInstitution';

axios.defaults.baseURL = `https://api.${getInstitution()}.aula.education/`;
